import {createSelector} from '@reduxjs/toolkit';
import isEqual from 'lodash.isequal';
import {createPredicates} from 'src/modules/events/filter-utils/createPredicates';
import {getEventsFilters} from 'src/modules/events/services/filters';
import {defaultState} from 'src/modules/events/services/filters/reducer';
import {getAllEventsCount} from 'src/modules/tabs-panel/services';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';
import {RootState} from 'src/store/store';
import {filterDataByPredicates} from 'src/utils/filterDataByPredicates';

export const getEventsInfo = (state: RootState): Array<EventBasicInfo> => state.eventsInfo.data;

export const getFilteredEvents = createSelector(
    [getEventsFilters, getEventsInfo],
    (filters, rows = []) => filterDataByPredicates(rows, filters, createPredicates),
);

export const getFilteredEventsLength = createSelector(
    [getFilteredEvents, getAllEventsCount, getEventsFilters],
    (filteredEvents, allEventsCount, filters) => {
        const isDefaultFilters = isEqual(filters, defaultState.data);

        return isDefaultFilters ? allEventsCount : filteredEvents.length;
    },
);
